var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6875 9C1.6875 4.96125 4.96125 1.6875 9 1.6875C13.0387 1.6875 16.3125 4.96125 16.3125 9C16.3125 13.0387 13.0387 16.3125 9 16.3125C4.96125 16.3125 1.6875 13.0387 1.6875 9ZM11.7075 7.6395C11.7525 7.57954 11.7851 7.51119 11.8033 7.43846C11.8215 7.36574 11.825 7.29011 11.8135 7.21602C11.8021 7.14192 11.7759 7.07087 11.7366 7.00702C11.6973 6.94318 11.6457 6.88783 11.5847 6.84424C11.5237 6.80064 11.4546 6.76968 11.3815 6.75317C11.3084 6.73666 11.2327 6.73494 11.1589 6.7481C11.0851 6.76126 11.0146 6.78904 10.9517 6.82981C10.8888 6.87058 10.8347 6.92351 10.7925 6.9855L8.3655 10.383L7.1475 9.165C7.04087 9.06564 6.89983 9.01155 6.75411 9.01412C6.60838 9.01669 6.46934 9.07572 6.36628 9.17878C6.26322 9.28184 6.20419 9.42088 6.20162 9.56661C6.19905 9.71233 6.25314 9.85337 6.3525 9.96L8.04 11.6475C8.09774 11.7052 8.16735 11.7496 8.24399 11.7777C8.32063 11.8058 8.40247 11.8169 8.48382 11.8102C8.56517 11.8035 8.64409 11.7792 8.7151 11.7389C8.7861 11.6986 8.84749 11.6434 8.895 11.577L11.7075 7.6395Z",
    fill: "#3E9C58"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickFilled);
export default __webpack_public_path__ + "static/media/tick-filled.3d76baf7612bf53d264c1bb8e463aba2.svg";
export { ForwardRef as ReactComponent };